<template>
  <modal :show.sync="showModal">
    <h6 slot="header" class="modal-title">Editar usuario: {{fetchUser.name}}</h6>
    <form class="needs-validation" id="formEditUser"
        @submit.prevent="sendForm">
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Nombre"
                      name="nombre"
                      placeholder="Ingrese un nombre"
                      :error="getError('nombre')"
                      v-validate="'required'"
                      v-model="user.name">
          </base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-input :label="labelRut"
                      :name="labelRut"
                      :placeholder="'Ingrese el '+labelRut+' de la persona'"
                      
                      v-model="user.dni">
          </base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Email"
                      name="email"
                      type="email"
                      placeholder="Ingrese una dirección de correo electrónico"
                      :error="getError('email')"
                      v-validate="'required|email'"
                      v-model="user.email">
          </base-input>
        </div>
      </div>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Sponsor" 
                v-model="user.sponsor"
                name="Sponsor"
                :error="getError('Sponsor')"
                v-validate="'required'"
                >
                    <el-select v-model="user.sponsor" filterable
                                placeholder="Seleccione Sponsor"
                                @change="updateSucursales"
                                >
                        <el-option v-for="option in selectSponsors"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Sucursal"
                v-model="user.sucursal"
                name="Sucursal"
                :error="getError('Sucursal')"
                v-validate="'required'"
                >
                    <el-select v-model="user.sucursal" filterable
                                placeholder="Seleccione Sucursal"
                                @change="updateTeams"
                                >
                        <el-option v-for="option in selectSucursales"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <div class="form-row">
          <div class="col-md-12">
                <base-input label="Equipo"
                v-model="user.equipo"
                name="Equipo"
                :error="getError('Equipo')"
                v-validate="'required'"
                >
                    <el-select v-model="user.equipo" filterable
                                placeholder="Seleccione equipo">
                        <el-option v-for="option in selectOptions"
                                    :key="option.label"
                                    :label="option.label"
                                    :value="option.value">
                        </el-option>
                    </el-select>
                </base-input>
          </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Contraseña"
                      name="contraseña"
                      type="password"
                      placeholder="Ingrese una contraseña"
                      :error="getError('password')"
                      v-validate="reglasPassword"
                      ref="contraseña"
                      :disabled="change_password=='0'"
                      v-model="user.password">
          </base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-12">
          <base-input label="Confrmar contraseña"
                      name="confirmar"
                      type="password"
                      placeholder="Ingrese nuevamente la contraseña"
                      :error="getError('confirmar')"
                      :disabled="change_password=='0'"
                      v-validate="reglasConfirmacion"
                      v-model="user.password_confirmation">
          </base-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
            <base-radio ref="cambiar" name="0" class="mb-3" v-model="change_password">
                Mantener Contraseña
            </base-radio>
        </div>
        <div class="col-md-6">
            <base-radio ref="cambiar" name="1" class="mb-3" v-model="change_password">
                Cambiar Contraseña
            </base-radio>
        </div>
      </div>

      <div class="form-row">
         <div class="col-md-12">
              <base-input label="Sponsors Garantías"
              v-model="user.garantee_sponsors"
              name="Sponsors Garantías"
              :error="getError('Sponsors Garantías')"
            
              >
                  <el-select v-model="user.garantee_sponsors" filterable multiple
                              placeholder="Seleccione Sponsors para Garantías">
                      <el-option v-for="option in selectSponsors"
                                  :key="option.label"
                                  :label="option.label"
                                  :value="option.value">
                      </el-option>
                  </el-select>
              </base-input>
        </div>
      </div>
      
      <!--
      <base-input>
        <base-checkbox v-model="model.agree">
          Agree to terms and conditions
        </base-checkbox>
      </base-input>
      -->
    </form>

    <template slot="footer">
      <base-button type="primary" nativeType="submit" form="formEditUser">Guardar Cambios</base-button>
      <base-button type="link" class="ml-auto" @click="showModal = false">Cancelar</base-button>
    </template>

  </modal>
</template>
<script>
import { Select, Option } from 'element-ui';

  export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
      return {
        validated: false,
        user: {
          name: '',
          email: '',
          password: '',
          password_confirmation: '',
          equipo: '',
          sucursal: '',
          sponsor: '',
          dni: '',
          garantee_sponsors: '',
        },
        fetchUser: {
          name: '',
          email: '',
          password: '',
          password_confirmation: '',
          equipo: ''
        },
        showModal: false,
        change_password: "0",
        reglasConfirmacion: '',
        reglasPassword: '',
        user_id: null,
        selectOptions: [], // Este debe ser un arreglo de objetos asi: { label: ...(es lo que se ve), value: ...}
        selectSucursales: [],
        selectSponsors: [],
        selectSponsorsG: [ { label: 'Sponsor 1', value: '1' }, { label: 'Sponsor 2', value: '2' } ]
      }
    },
    methods: {
      async firstFormSubmit() {
        try {
          return await this.$validator.validateAll();
          //throw new Error('hno ke wea esta wea');
        } catch {
          console.log('Oh, tengo ke caputar algo');
          return false;
        }
        finally {
          this.validated = true;
        }
      },
      getError(name){
        return this.errors.first(name)
      },
      isValid(name) {
        return this.validated && !this.errors.has(name);
      },
      updateSucursales(autocompletar = true)
      {
        var vm = this;
        this.axios({
          url: 'api/test_list_sucursales_from_create_user?sponsor='+this.user.sponsor,
          method: 'GET',
        }).then( response =>{
          vm.selectSucursales = response.data;
          if(autocompletar){
              if( response.data.length >= 1 ){
              vm.user.sucursal = response.data[0].value;
              vm.updateTeams();
              }else{
                vm.user.sucursal = undefined;
              }
          }else{
            vm.updateTeams(false);
          }
          
          
        })
        ;
      },
      updateTeams(autocompletar = true){
        var vm = this;
        this.axios({
          url: 'api/test_list_teams_from_create_user?sucursal='+this.user.sucursal,
          method: 'GET',
        }).then( response =>{
          vm.selectOptions = response.data;
          if(autocompletar){
            if( response.data.length >= 1 ){
              vm.user.equipo = response.data[0].value;
            }else{
              vm.user.equipo = undefined;
            }
          }
          
        })
        ;
      },
      sendForm(){
        var vm = this;
        this.firstFormSubmit().then( response => {
          console.log('retorno promesa de validacion', response);
          if( response ){
            
            vm.axios({
                method: 'PUT',
                url: 'api/edit_user?user='+vm.user_id,
                data: {   nombre: vm.user.name, 
                          equipo: vm.user.equipo,
                          email: vm.user.email,
                          contraseña: vm.user.password,
                          contraseña_confirmation: vm.user.password_confirmation,
                          change_password: vm.change_password,
                          sucursal: vm.user.sucursal,
                          sponsor: vm.user.sponsor,
                          dni: vm.user.dni,
                          garantee_sponsors: vm.user.garantee_sponsors
                      }
            }).then( response => {
              vm.$notify({
                      message: 'Usuario editado exitosamente!',
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'success'
                  });
              // Cerrar el Modal
              vm.showModal = false;
              // Emitir evento para que actualize la tabla de usuarios
              vm.$emit('successSending');
            }).catch( error => {
                
                if( error.response.status == 422){
                  Object.entries(error.response.data.errors).forEach( elem => {
                    vm.$notify({
                      message: elem[1][0],
                      timeout: 5000,
                      icon: 'ni ni-bell-55',
                      type: 'danger'
                    });
                  });
                }else{
                  console.log(error);
                  vm.$notify({
                        message: 'Hubo un error, no se pudo modificar el usuario',
                        timeout: 5000,
                        icon: 'ni ni-bell-55',
                        type: 'default'
                    });
                }
            });
          }
        }).catch( reason => {
          console.log(reason);
        });
      },
      fetchDataUser(user)
      {
        var vm = this;
        
        return this.axios({
            method: 'GET',
            url: 'api/edit_user?user='+user
        }).then(response => {
            vm.axios({
              method: 'GET',
              url: 'api/test_list_sponsors_from_create_user'
            }).then( res => {
              vm.selectSponsors = res.data;
              vm.fetchUser.name = vm.user.name = response.data.name;
              vm.user.email = response.data.email;
              vm.user.equipo = response.data.equipo;
              vm.user.sucursal = response.data.sucursal;
              vm.user.sponsor = response.data.sponsor;
              vm.user.dni = response.data.rut;
              vm.user.garantee_sponsors = response.data.user_guarantee_sponsors;
              vm.showModal = true;
              vm.user_id = user;
              if( res.data.length == 1 ){
                vm.user.sponsor = res.data[0].value;
                
              }
              vm.updateSucursales(false);
            });
            
            
        }).catch( error => {
            console.log(error);
        })
        ;
        
        
      }
    },
    mounted()
    {
        
    },
    created()
    {
      this.$parent.$on('loadModalEditUser', (user) => { 
        
        this.fetchDataUser(user); 
        
      } );
    },
    watch: {
        change_password(value)
        {
            if(this.change_password == '0'){
                this.user.password = '';
                this.user.password_confirmation = '';
                this.reglasPassword = ''
                this.reglasConfirmacion = '';
            } else {
                this.reglasPassword = 'required|min:6';
                this.reglasConfirmacion = 'required|min:6|confirmed:contraseña'
            }
        }
    },
    computed: {
      labelRut(){
        let pais = this.$store.state.user.pais_sponsor || '';
        switch(pais){
          case 'Chile':
            return 'RUT';
            break;
          case 'Colombia':
            return 'DNI';
            break;
          case 'Ecuador':
            return 'DNI';
            break;
          case 'Argentina':
            return 'DNI';
            break;
          default:
            return 'DNI';
            break;
        }
      }
    }
  }
</script>
<style>
</style>
